/**
 * Side-effect Leaflet setup for customer shop maps.
 * Import once before any MapContainer / Marker usage:
 *   import { shopMarkerIcon, userPositionIcon } from './leafletMapSetup.js';
 *   // or: import './leafletMapSetup.js';
 *
 * Vite rewrites Leaflet's default marker URLs to broken relative paths.
 * Bundle icons as same-origin assets (CSP img-src 'self') — do not use CDN.
 */
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';

delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

/** Shop / sales-point pin — standard Leaflet marker after asset fix. */
export const shopMarkerIcon: L.Icon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});

/**
 * User geolocation — solid blue circle DivIcon so it is not confusable
 * with the default shop pin.
 */
export const userPositionIcon: L.DivIcon = L.divIcon({
  className: 'rpapp-user-position-marker',
  html:
    '<div style="width:14px;height:14px;border-radius:50%;background:#2563eb;' +
    'border:2px solid #fff;box-shadow:0 0 0 1px rgba(37,99,235,0.45)"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});
